<template>
  <transition name="slide" v-if="operacao">
    <div class="right-sheet" v-click-outside="handleClose">
      <i class="material-icons-outlined icon-close" @click="handleClose">close</i>
      <div v-if="sequenciada" class="actions">
        <button class="action-btn" @click="divide">
          <i class="material-icons-outlined">unfold_more</i>
        </button>
        <button @click="junta" class="action-btn">
          <i class="material-icons-outlined">unfold_less</i>
        </button>
      </div>
      <h2 class="rs-title">{{ operacao.slice(1) }}</h2>
      <div class="rs-info">
        <p class="rs-info-item">
          <span class="rs-info-item-title">Produto</span>
          <span class="rs-info-item-row">JH7123</span>
          <span class="rs-info-item-row">Exaustor</span>
        </p>
        <p class="rs-info-item">
          <span class="rs-info-item-title">Maquina</span>
          <span class="rs-info-item-row">IN2901</span>
          <span class="rs-info-item-row">Parafusadeira</span>
        </p>
        <p class="rs-info-item">
          <span class="rs-info-item-title">Operação</span> primeira
        </p>
        <p class="rs-info-item">
          <span class="rs-info-item-title">Data inicio</span> 19/02/2020
          14:00:00
        </p>
        <p class="rs-info-item">
          <span class="rs-info-item-title">Data fim</span> 02/04/2020 15:45:00
        </p>
        <p class="rs-info-item">
          <span class="rs-info-item-title">Status</span> produzindo
        </p>
        <p class="rs-info-item">
          <span class="rs-info-item-title">Quantidade Planejada</span> 25
        </p>
        <p class="rs-info-item">
          <span class="rs-info-item-title">Quantidade Boas</span> 19
        </p>
        <p class="rs-info-item">
          <span class="rs-info-item-title">Quantidade Defeituosas</span> 0
        </p>
      </div>
      <button
        v-if="isMoveable"
        class="rs-btn"
        :class="{ danger: sequenciada }"
        @click="handleMove"
      >{{ sequenciada ? "Desequenciar" : "Sequenciar" }}</button>
    </div>
  </transition>
</template>

<script>
import clickOutside from "@/directives/clickOutside";

export default {
  name: "RightSheet",
  computed: {
    sequenciada() {
      return this.$store.state.rightSheet.sequenciada;
    },
    operacao() {
      const op = this.$store.state.rightSheet.operacao;
      return op;
    },
    isMoveable() {
      if (!this.sequenciada) {
        return true;
      }
      const relatedOrder = this.$store.getters.getOrder(this.operacao);
      const now = new Date().getTime();
      return relatedOrder.time.start > now;
    }
  },
  methods: {
    handleClose() {
      this.$store.commit("changeRightSheetOp", {});
    },
    handleMove() {
      //const relatedOrder = this.$store.getters.getOrder(this.operacao);
      if (this.sequenciada) {
        this.$store.commit("removeSequencedOrder", this.operacao);
      } else {
        this.$store.commit("removeFreeOrder", this.operacao);
      }
      this.handleClose();
    },
    divide() {
      const relatedOrder = this.$store.getters.getOrder(this.operacao);
      this.$store.commit("divideOrder", relatedOrder);
      this.handleClose();
    },
    junta() {
      const relatedOrder = this.$store.getters.getOrder(this.operacao);
      this.$store.commit("joinOrders", relatedOrder);
      this.handleClose();
    }
  },
  directives: {
    "click-outside": clickOutside
  }
};
</script>

<style scoped>
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.7s ease-in-out;
}

.slide-enter,
.slide-leave-to {
  transform: translateX(100%);
}
.slide-enter-to,
.slide-leave {
  transform: translateX(0%);
}

.right-sheet {
  background-color: var(--color-white);
  height: 100%;
  top: 0;
  right: 0;
  width: 20%;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  position: absolute;
}

.material-icons-outlined.icon-close {
  position: absolute;
  right: 0;
  margin: 0.1rem;
  cursor: pointer;
  font-size: 1.1rem;
  color: var(--color-blue);
  background: rgba(250, 250, 250, 0.8);
  border-radius: 50%;
}

.rs-title {
  height: 6vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--color-blue);
  margin: 0;
  color: var(--color-white);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

.rs-info {
  padding: 0 0.2rem;
  margin-bottom: 3rem;
}

.rs-info-item {
  height: 8.5vh;
  border-bottom: 1px solid var(--color-grey);
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-weight: 500;
  position: relative;
  margin: 0;
}

.rs-info-item-title {
  font-weight: normal;
  display: block;
  position: absolute;
  top: 0em;
  left: 0;
  max-width: 5em;
  text-align: left;
  font-size: 0.8em;
}

.rs-info-item-row {
  display: block;
}

.rs-info-item-row ~ .rs-info-item-row {
  margin-top: 0.1em;
}

.rs-btn {
  outline: 0;
  border: none;
  width: calc(100% - 0.4rem);
  margin: 0 auto;
  display: block;
  font-family: inherit;
  background: var(--color-blue);
  color: var(--color-white);
  border-radius: 0.2rem;
  padding: 0.7rem 0;
  font-weight: bold;
  font-size: 1.2em;
  cursor: pointer;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}
.action-btn {
  outline: 0;
  border: none;
  border-radius: 50%;
  padding: 0 0.05rem;
  cursor: pointer;
  background: rgba(250, 250, 250, 0.8);
  font-size: 1.1rem;
  transform: rotate(90deg);
  margin-right: 0.4rem;
}

.action-btn .material-icons-outlined {
  color: var(--color-blue);
  font-size: 1.1rem;
  position: relative;
  top: 0.16em;
}

.actions {
  position: absolute;
  padding: 0 0.3rem;
}

.rs-btn.danger {
  background: var(--color-red);
}

.material-icons.md-large {
  font-size: 2.2rem;
}
</style>
